const DECRYPT_ACTIONS = {
  CA_BZT: { ca: true, bzt: true },
  CA_ONLY: { ca: true, bzt: false },
  BZT_ONLY: { ca: false, bzt: true },
  NONE: { ca: false, bzt: false },
};

function ensureValue(value, message) {
  if (value === undefined || value === null || value === '') {
    throw new Error(message);
  }
  return value;
}

function getDecryptActions(decryptMode) {
  const actions = DECRYPT_ACTIONS[decryptMode];
  if (!actions) {
    throw new Error('不支持的解密模式');
  }
  return { ...actions };
}

function getDecryptResponseAction(responseData) {
  const data = responseData || {};
  return {
    toInsure: String(data.toInsure) === '1',
    redirectUrl: data.redirectUrl || '',
  };
}

function decodeBase64Utf8(value) {
  if (typeof value !== 'string') return '';
  const normalized = value.trim();
  if (!normalized || normalized.length % 4 !== 0 || !/^[A-Za-z0-9+/]+={0,2}$/.test(normalized)) {
    return '';
  }
  try {
    if (typeof Buffer !== 'undefined') {
      const decoded = Buffer.from(normalized, 'base64').toString('utf8');
      const encoded = Buffer.from(decoded, 'utf8').toString('base64').replace(/=+$/, '');
      return encoded === normalized.replace(/=+$/, '') ? decoded : '';
    }
    const binary = atob(normalized);
    const bytes = new Uint8Array(binary.length);
    for (let index = 0; index < binary.length; index += 1) {
      bytes[index] = binary.charCodeAt(index);
    }
    return typeof TextDecoder !== 'undefined'
      ? new TextDecoder('utf-8').decode(bytes)
      : decodeURIComponent(escape(binary));
  } catch (error) {
    return '';
  }
}

function buildEnvelopeCandidates(envelope) {
  const raw = ensureValue(envelope, '数字信封为空');
  const candidates = [ raw ];
  const decoded = decodeBase64Utf8(raw);
  if (decoded && decoded !== raw) candidates.push(decoded);
  return candidates;
}

function buildDigitalEnvelopePayload(orderNo, decryptedEnvelope) {
  const scopedOrderNo = ensureValue(orderNo, '订单号为空');
  const decrypted = ensureValue(decryptedEnvelope, 'CA解密结果为空');
  let payload;
  try {
    payload = JSON.parse(decrypted);
  } catch (error) {
    payload = {
      type: 'tbaohan',
      applyno: scopedOrderNo,
      encryptkey: decrypted,
    };
  }
  if (payload.type !== 'tbaohan' || !payload.applyno || !payload.encryptkey) {
    throw new Error('CA解密结果缺少必要字段');
  }
  if (payload.applyno !== scopedOrderNo) {
    throw new Error('CA解密结果中的业务流水号不一致');
  }
  return {
    orderNo: scopedOrderNo,
    type: payload.type,
    applyno: payload.applyno,
    encryptkey: payload.encryptkey,
  };
}

function buildBztQrcodeParams(orderNo) {
  return { orderNo: ensureValue(orderNo, '订单号为空') };
}

function buildBztQueryParams(orderNo, qrcodeid) {
  return {
    orderNo: ensureValue(orderNo, '订单号为空'),
    qrcodeid: ensureValue(qrcodeid, '标证通二维码编号为空'),
  };
}

function extractBztQrcode(responseData) {
  const qrInfo = responseData && responseData.qrInfo;
  return {
    qrcodeid: ensureValue(qrInfo && qrInfo.qrcodeid, '标证通二维码编号为空'),
    content: ensureValue(qrInfo && qrInfo.content, '标证通二维码内容为空'),
  };
}

function isTrustedBridgeMessage(event, expected) {
  const data = event && event.data;
  return Boolean(
    event && expected &&
    event.origin === expected.origin &&
    event.source === expected.source &&
    data &&
    (data.type === 'QUOTA_CA_RESULT' || data.type === 'QUOTA_CA_ERROR') &&
    data.nonce === expected.nonce
  );
}

function isPollingGenerationActive(generation, currentGeneration, visible, qrcodeid) {
  return generation === currentGeneration && Boolean(visible && qrcodeid);
}

function resolveSafeQuotaRedirect(redirectUrl, context) {
  const origin = context && context.origin;
  const channelCode = context && context.channelCode;
  const orderNo = context && context.orderNo;
  const fallback = new URL('/insureQuota', origin);
  fallback.searchParams.set('channelCode', channelCode || '');
  fallback.searchParams.set('orderNo', orderNo || '');
  if (!redirectUrl) return fallback.href;

  try {
    const target = new URL(redirectUrl, origin);
    if (
      target.origin === origin &&
      target.pathname === '/insureQuota' &&
      target.searchParams.get('channelCode') === channelCode &&
      target.searchParams.get('orderNo') === orderNo
    ) {
      return target.href;
    }
  } catch (error) {
    return fallback.href;
  }
  return fallback.href;
}

module.exports = {
  buildDigitalEnvelopePayload,
  buildEnvelopeCandidates,
  buildBztQrcodeParams,
  buildBztQueryParams,
  extractBztQrcode,
  getDecryptActions,
  getDecryptResponseAction,
  isPollingGenerationActive,
  isTrustedBridgeMessage,
  resolveSafeQuotaRedirect,
};
